import { computed, inject } from 'vue';
export const INPUT_PRESENTATIONS = Symbol('input-presentations');
export const INPUT_DEPTH = Symbol('input-depth');
export const INPUT_PRESENTATION_INTRO = Symbol('input-presentation-intro');
export const INPUT_FOOTER = Symbol('input-footer');
export const ROOT_INPUT_FOOTER = Symbol('root-input-footer');
export function useInputPresentation(kind) {
    const presentations = inject(INPUT_PRESENTATIONS, undefined);
    return computed(() => presentations?.value?.[kind]);
}
